import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=f3c78c5e&scoped=true"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=f3c78c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c78c5e",
  null
  
)

export default component.exports